"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Line = exports.ProductTitle = exports.ProductIcon = exports.ImageContainer = exports.ProductContainer = exports.CustomerTypeTitle = exports.CustomerTypeColumn = exports.MenuContainer = exports.Dropdown = exports.Icon = exports.Label = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _fa = require("react-icons/fa");

var _Link = _interopRequireDefault(require("../../components/Link"));

var _theme = require("../../../style/theme");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Label = _styledComponents.default.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  font-weight: bold;\n  color: ", ";\n  cursor: ", ";\n"])), (0, _theme.th)("colors.white"), function (_ref) {
  var disabled = _ref.disabled;
  return disabled ? "default" : "pointer";
});

exports.Label = Label;
var Icon = (0, _styledComponents.default)(_fa.FaCaretDown)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin-left: 8px;\n  color: inherit;\n  transition: transform 0.3s;\n  cursor: ", ";\n"])), function (_ref2) {
  var disabled = _ref2.disabled;
  return disabled ? "default" : "pointer";
});
exports.Icon = Icon;

var Dropdown = _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  position: absolute;\n  display: flex;\n  flex-direction: row;\n  left: -10%;\n  top: 55px;\n  width: 630px;\n  padding: 24px;\n  padding-bottom: 32px;\n  border-radius: 6px;\n  background-color: ", ";\n  box-shadow: ", ";\n  z-index: ", ";\n  transition: opacity 0.2s;\n\n  &::after {\n    content: \" \";\n    position: absolute;\n    left: 42px;\n    bottom: 100%;\n    border-width: 8px;\n    border-style: solid;\n    border-color: transparent transparent ", "\n      transparent;\n  }\n"])), (0, _theme.th)("colors.darkSlateGray"), (0, _theme.th)("shadows.small"), _theme.zIndexes.navigation, (0, _theme.th)("colors.darkSlateGray"));

exports.Dropdown = Dropdown;

var MenuContainer = _styledComponents.default.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  position: relative;\n  display: flex;\n  height: 100%;\n\n  > ", " {\n    opacity: 0;\n    pointer-events: none;\n  }\n\n  &:hover {\n    > ", " {\n      opacity: 1;\n      pointer-events: initial;\n    }\n\n    > ", " > ", " {\n      transform: rotate(180deg);\n    }\n  }\n"])), Dropdown, function (_ref3) {
  var disabled = _ref3.disabled;
  return !disabled && Dropdown;
}, Label, Icon);

exports.MenuContainer = MenuContainer;

var CustomerTypeColumn = _styledComponents.default.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  flex: 1;\n\n  :not(:first-child) {\n    margin-left: 16px;\n  }\n"])));

exports.CustomerTypeColumn = CustomerTypeColumn;

var CustomerTypeTitle = _styledComponents.default.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  margin-bottom: 20px;\n  font-weight: bold;\n  color: ", ";\n"])), (0, _theme.th)("colors.white"));

exports.CustomerTypeTitle = CustomerTypeTitle;
var ProductContainer = (0, _styledComponents.default)(_Link.default)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  display: flex;\n  text-decoration: none;\n  color: ", ";\n\n  :hover {\n    color: ", ";\n    opacity: 1;\n  }\n\n  :not(:last-child) {\n    margin-bottom: 20px;\n  }\n"])), (0, _theme.th)("colors.white"), (0, _theme.th)("colors.white"));
exports.ProductContainer = ProductContainer;

var ImageContainer = _styledComponents.default.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 60px;\n  margin-right: 16px;\n"])));

exports.ImageContainer = ImageContainer;

var ProductIcon = _styledComponents.default.img(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  width: ", ";\n  margin-left: ", ";\n"])), function (_ref4) {
  var imageWidth = _ref4.imageWidth;
  return "".concat(imageWidth, "px");
}, function (_ref5) {
  var imgMarginLeft = _ref5.imgMarginLeft;
  return "".concat(imgMarginLeft, "px");
});

exports.ProductIcon = ProductIcon;

var ProductTitle = _styledComponents.default.div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  margin-bottom: 4px;\n  font-weight: bold;\n  color: ", ";\n"])), function (_ref6) {
  var $color = _ref6.$color;
  return $color;
});

exports.ProductTitle = ProductTitle;

var Line = _styledComponents.default.div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  flex: 1;\n  height: 1px;\n  margin: 0 16px;\n  background-color: ", ";\n"])), (0, _theme.th)("colors.white"));

exports.Line = Line;